<script setup>
defineProps({
  category: {
    type: String,
    required: true
  },
  label: {
    type: String,
    required: true
  }
})
defineEmits(['click'])
</script>

<template>
  <button
    :data-weather="category"
    :data-selected="category === 'livecam'"
    @click="$emit('click')"
  >
    <span>
      <figure>
        <img
          :src="generateIconSrc(category)"
          width="24"
          height="24"
          alt=""
        >
      </figure>
    </span>
    <span>{{ label }}</span>
  </button>
</template>

<style lang="scss" scoped>
</style>
